/* eslint-disable no-unused-vars */
import React from 'react';
import moment from 'moment';
import { v4 as uuid } from 'uuid';

import { DELIVERY_STATUS_ENUM_TRANSKEY } from '../../../../../../../enums/nf-status';

import {
  Container,
  ContainerStatus,
  IconContainer,
  IconContent,
  LeftConnectionLine,
  RightConnectionLine,
  StatusName,
  StatusNameWrapper,
  TransferBadge,
  TransferTooltip,
  SubtitleText,
} from './styles';

import { LinkText, LinkWrapper } from '../styles';

import Icon from '../../../../../../../components/Icon';

import { Colors } from '../../../../../../../constants';
import { IconsTMS, IconsWMS } from '../../../../../../../components/StatusFlow/singleStatus/Icons/IconsStatus';

function SingleStatus({
  deliveryType,
  isWMS,
  stepType,
  changedStatusAt,
  notHired,
  first,
  last,
  title,
  isMobile,
  notStarted,
  completed,
  onHold,
  inProgress,
  renderBottom,
  hasReceipts,
  openReceipt,
  isAgroDivision,
  transferTripsCount,
  branchNameSource,
  branchNameDestination,
}) {
  const isDeliveryType = deliveryType !== null && deliveryType !== undefined;

    const getColor = () => {
    if (completed) {
      return Colors.SECONDARY_LIGHT_DARK;
    } else if (inProgress || onHold) {
      return Colors.PRIMARY_BLUE;
    } else if (notStarted) {
      return Colors.GREY_150;
    }
  }

  const getColorsRadios1 = () => {
    if (completed) {
      return Colors.PRIMARY_LIGHT_BLUE;
    } else if (inProgress || onHold) {
      return Colors.PRIMARY_BLUE;
    } else if (notStarted) {
      return Colors.GREY_150;
    }
  }

  const getColorsRadios2 = () => {
    if (completed || inProgress || onHold) {
      return Colors.PRIMARY_LIGHTER_BLUE;
    } else if (notStarted) {
      return Colors.GREY_150;
    }
  }

  const getIconsWMS = (stepType) => {
    if (IconsWMS[stepType]) {
      return IconsWMS[stepType]({
        uuid: uuid(), 
        radiosColor1: getColorsRadios1(), 
        radiosColor2: getColorsRadios2(), 
        color: getColor()  
      })
    }
  }

  const getIconsTMS = (stepType) => {
    if (IconsTMS[stepType]) {
      return IconsTMS[stepType]({
        uuid: uuid(), 
        radiosColor1: getColorsRadios1(), 
        radiosColor2: getColorsRadios2(), 
        color: getColor() 
      })
    }
  }

  return (
    <Container isMobile={isMobile}>
      <IconContainer>
        {!first && <RightConnectionLine grayLine={notStarted} />}
        {isWMS ? (
          <IconContent>
            {getIconsWMS(stepType)}
          </IconContent> 
        ) : (
          <IconContent>
            {getIconsTMS(stepType)}
          </IconContent>
        )}
        {!last && (
          <LeftConnectionLine
            grayLine={notStarted || onHold}
          />
        )}
      </IconContainer>

      <ContainerStatus>
        <StatusNameWrapper>
          <StatusName
            notStarted={notStarted}
            activeStatus={inProgress || onHold}
          >
            {title}
          </StatusName>
          {transferTripsCount > 0 && (
            <TransferTooltip
              arrow
              title={`${transferTripsCount} transferência${transferTripsCount > 1 ? 's' : ''} entre filiais`}
              placement="top"
            >
              <TransferBadge
                notStarted={notStarted}
                activeStatus={inProgress || onHold}
                completed={completed}
              >
                +{transferTripsCount}
              </TransferBadge>
            </TransferTooltip>
          )}
        </StatusNameWrapper>
        <SubtitleText uppercase>{notStarted ? 'Pendente' : ''}</SubtitleText>

        {isDeliveryType ? (
          <SubtitleText uppercase>
            {DELIVERY_STATUS_ENUM_TRANSKEY[deliveryType]}
          </SubtitleText>
        ) : null}

        {changedStatusAt && !notHired && (
          <SubtitleText>
            {isAgroDivision ? moment(changedStatusAt).format('DD/MM/YYYY') : moment(changedStatusAt).format('DD/MM/YYYY HH:mm')}
          </SubtitleText>
        )}
        {branchNameSource && (
          <>
            <SubtitleText>Local de origem:</SubtitleText>
            <SubtitleText>{branchNameSource.split(' - ').pop()}</SubtitleText>
          </>
        )}
        {branchNameDestination && (
          <>
            <SubtitleText>Local de destino:</SubtitleText>
            <SubtitleText>{branchNameDestination.split(' - ').pop()}</SubtitleText>
          </>
        )}
        {renderBottom && renderBottom}

        {isDeliveryType && hasReceipts ? (
          <LinkWrapper onClick={openReceipt}>
            <LinkText>Ver Comprovante</LinkText>
            <Icon name="with-image" />
          </LinkWrapper>
        ) : null}
      </ContainerStatus>
    </Container>
  );
}

export default SingleStatus;
